import { FC, HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

import HtmlText from "../common/HtmlText";
import TwoColumnTab, { ITwoColumnTab } from "../blog-details/TwoColumnTab";

// ------------------------------------------------------------------------------------

export type IContentWithTabsSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  description?: ReactNode;
  tabs?: ITwoColumnTab[];
};

const ContentWithTabsSection: FC<IContentWithTabsSectionProps> = (props) => {
  const { heading, description, tabs, className, ...other } = props;

  return (
    <section className="py-5 lg:py-8 xl:py-[50px]">
      <div
        className={clsx(
          "bg-primary-950 py-10 lg:py-16 xl:py-[100px]",
          className,
        )}
        {...other}
      >
        <div className="container">
          {heading && (
            <h2 className="text-h5 font-medium leading-tight text-white lg:text-h3 xl:w-[750px] xl:text-h2">
              {heading}
            </h2>
          )}

          {description && (
            <HtmlText className="my-5 prose-headings:text-white prose-p:text-white prose-strong:text-white prose-li:!text-white xl:my-8">
              {description}
            </HtmlText>
          )}

          {tabs && tabs.length !== 0 && (
            <TwoColumnTab
              tabs={tabs}
              leftDescriptionClass="prose-p:text-white prose-strong:text-white prose-headings:text-white prose-li:!text-white"
              rightDescriptionClass="prose-p:text-white prose-strong:text-white prose-headings:text-white prose-li:!text-white"
              tabHeadingClass="text-white"
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default ContentWithTabsSection;
